<template>
  <v-container class="pa-0"  fluid>
    <component :is="routeItems[activeRoute].component" class=""></component>
  </v-container>
</template>

<script>
import { authRoute } from '@/router/routeRole'
import SearchNew from '@/views/search/searchNew/SearchNew.vue'
import SearchList from '@/views/search/searchList/SearchList.vue'
import SearchOrders from '@/views/search/searchOrders/SearchOrders.vue'
import AdminOrderForm from '@/views/search/searchOrders/AdminOrderForm.vue'


export default {
  name: 'SearchTab',
  data() {
    return {
      selectedTab: null,
    }
  },
  computed: {
    routeItems() {
      return [
        {
          title: 'Paieška',
          route: 'searchNew',
          component: SearchNew,
        },
        {
          title: 'Paieškų sąrašas',
          route: 'searchList',
          component: SearchList,
        },
        {
          title: 'Išrašų užsakymas',
          route: 'searchOrders',
          component: SearchOrders,
        },
         {
          title: 'Išrašas',
          route: 'adminOrderForm',
          component: AdminOrderForm,
        },
        {
          title: 'Išrašas',
          route: 'adminOrderFormList',
          component: AdminOrderForm,
        },
        
      ]
    },
    tabItems() {
      return this.routeItems.filter((item) => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.tabItems.findIndex(function (item, index) {
          return this.$route.matched.find((element) => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.routeItems.findIndex(function (item, index) {
        if (item.route === this.$route.name) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
